import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getLoginUrl } from '@/selectors/configSelectors';
import { useRouteParams } from '@/context/routeParamsContext';
import {
  getIsCheckingAuth,
  getIsNotLoggedIn,
  getIsLoggedIn,
} from '@/selectors/authSelectors';
import { getWalletIsLoading } from '@/selectors/walletSelector';
import { Card, pageSessionKey, loginPageValue } from '@/constants';
import { useCenturionProductFromUserWallet } from './memberHooks';

export const useIsRedirectingCenturionToLogin = () => {
  const { product } = useRouteParams();
  const isLoggedIn = useSelector(getIsLoggedIn);
  const isNotLoggedIn = useSelector(getIsNotLoggedIn);
  const isCheckingAuth = useSelector(getIsCheckingAuth);
  const isWalletLoading = useSelector(getWalletIsLoading);
  const centurionProduct = useCenturionProductFromUserWallet();
  const isCenturionProduct = product === Card.Centurion;

  const loggedOutCheck =
    isCenturionProduct && (isCheckingAuth || isNotLoggedIn);
  const loggedInCheck =
    isCenturionProduct && isLoggedIn && !centurionProduct && !isWalletLoading;

  return loggedOutCheck || loggedInCheck;
};

export const useCenturionForcedLoginRedirection = ({ params, locale }) => {
  const isLoggedIn = useSelector(getIsLoggedIn);
  const isNotLoggedIn = useSelector(getIsNotLoggedIn);
  const loginOrigin = useSelector(getLoginUrl);
  const isWalletLoading = useSelector(getWalletIsLoading);
  const centurionProduct = useCenturionProductFromUserWallet();
  const isCenturionProduct = params?.product === Card.Centurion;
  // check if browser exists since this hook runs on the server as well
  const returnUrl = global.BROWSER ? window.location.href : '';

  useEffect(() => {
    if (isNotLoggedIn && isCenturionProduct) {
      const fullUrl = `${loginOrigin}/${locale}/account/login?DestPage=${encodeURIComponent(returnUrl)}`;
      // check if browser exists since this hook runs on the server as well
      if (global.BROWSER) {
        window.sessionStorage.setItem(pageSessionKey, loginPageValue);
        window.location.assign(fullUrl);
      }
    }

    if (
      isLoggedIn &&
      isCenturionProduct &&
      !centurionProduct &&
      !isWalletLoading
    ) {
      const fullUrl = `${loginOrigin}/${locale}/account/logout?DestPage=${encodeURIComponent(returnUrl)}`;
      // check if browser exists since this hook runs on the server as well
      if (global.BROWSER) {
        window.location.assign(fullUrl);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only run when the product changes & wallet is done loading
  }, [params?.product, isWalletLoading]);
};
